// Cash Transactions State

export default {
  transactionsList: [],
  transactionInfo: {},
  cashList: []
}
